import { OrthoMask, Polygon } from "@nova/protobuf"
import {
    booleanValidator,
    createdByValidators,
    entityValidator,
    idValidators,
    UnionToTuple,
} from "../util"
import { isValidLonLat } from "@nova/calculate-geospatial"
import { dateAsNumber } from "../../util"

const polygonValidators = [
    {
        validator: (polygon: Polygon) =>
            polygon.coordinates.length >= 3 &&
            polygon.coordinates.every((coordinate) => isValidLonLat(coordinate)),
        error: "OrthoMask polygon is invalid",
    },
]

const flightIdValidator = [
    {
        validator: (val: string) => val.length > 0,
        error: "flightId must be non-empty",
    },
]

export const createOrthoMaskValidator = entityValidator(OrthoMask, {
    id: { validators: idValidators, nonNull: true },
    flightId: { validators: flightIdValidator, nonNull: true },
    polygon: { validators: polygonValidators, nonNull: true },
    enabled: { validators: booleanValidator("enabled"), nonNull: true },
    createdBy: { validators: createdByValidators },
})

export const updateOrthoMaskValidator = entityValidator(OrthoMask, {
    polygon: { validators: polygonValidators },
    enabled: { validators: booleanValidator("enabled"), nonNull: true },
})

export const getDefaultOrthoMaskCreateArgs = () => ({
    createdAt: dateAsNumber(),
    enabled: true,
})

export type CreateOrthoMaskArgs = UnionToTuple<keyof typeof createOrthoMaskValidator>
export type UpdateOrthoMaskArgs = UnionToTuple<keyof typeof updateOrthoMaskValidator>
